import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import backgroundImage from './images/bg30.png';

const Header = () => {
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        height: { xs: 'auto', md: '100vh' },
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#f9fafc',
        pt:{xs:'100px',md:'0px'}
      }}
    >
      {/* Left: Image Section */}
      <Box
        sx={{
          width: { xs: '100%', md: '50%' },
          height: { xs: '250px', sm: '300px', md: '100%' },
          minHeight: { xs: '250px', sm: '300px', md: '450px' },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {imageError ? (
          <Box
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: '#ddd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography>Image failed to load</Typography>
          </Box>
        ) : (
          <Box
            component="img"
            src={backgroundImage}
            alt="WatchNod Landscape"
            title="WatchNod Header Landscape"
            width="768"
            height="768"
            loading="eager"
            fetchPriority="high"
            decoding="async"
            onError={() => setImageError(true)}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
              aspectRatio: '1 / 1',
            }}
          />
        )}
      </Box>

      {/* Right: Content Section */}
      <Box
        sx={{
          width: { xs: '100%', md: '50%' },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: { xs: 'center', md: 'flex-start' },
          textAlign: { xs: 'center', md: 'left' },
          px: { xs: 3, sm: 4, md: 8 },
          py: { xs: 4, sm: 6 },
          backgroundColor: '#ffffff',
        }}
      >
        {/* Main H1 for SEO - Visible and descriptive */}
        <Typography
          component="h1"
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            mb: 2,
            lineHeight: 1.3,
            color: 'text.primary',
          }}
        >
          WatchNod: Server Health & API Monitoring
        </Typography>

        <Typography
          component="h2"
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
            mb: 2,
            lineHeight: 1.3,
            color: 'text.secondary',
          }}
        >
          Ensure Peak Performance with Real-Time Node & API Monitoring
        </Typography>

        <Typography
          component="p"
          variant="h6"
          sx={{
            color: 'text.secondary',
            mb: 4,
            maxWidth: { xs: '100%', md: 700 },
          }}
        >
          Keep your websites and systems running smoothly with smart alerts, performance tracking, and easy setup.
        </Typography>

        <Button
          component="a"
          href="/signup"
          variant="contained"
          size="large"
          onClick={(e) => {
            e.preventDefault();
            navigate('/signup');
          }}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            borderRadius: '999px',
            textTransform: 'none',
            textDecoration: 'none',
          }}
        >
          Start Monitoring for Free
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
